import {
	createUserWithEmailAndPassword,
	getAuth,
	sendEmailVerification,
	sendPasswordResetEmail,
	signInWithEmailAndPassword,
	signOut,
	updateProfile,
	verifyBeforeUpdateEmail,
	signInAnonymously,
} from 'firebase/auth'

export async function verifyEmail(currentPassword, email) {
	const auth = getAuth()
	const user = auth.currentUser
	const actionCodeSettings = {
		url: `${process.env.REACT_APP_PUBLIC_URL}/login`,
		handleCodeInApp: true,
	}
	const userCredential = await signInWithEmailAndPassword(auth, user.email, currentPassword)
	return verifyBeforeUpdateEmail(userCredential.user, email, actionCodeSettings)
}

export async function sendVerification(actionCodeSettings) {
	const auth = getAuth()
	const user = auth.currentUser
	return sendEmailVerification(user, actionCodeSettings)
}

export function userSignIn(email, password) {
	const auth = getAuth()
	return signInWithEmailAndPassword(auth, email, password)
}

export async function createUser({ email, password, firstName, lastName }) {
	const auth = getAuth()
	const userCredential = await createUserWithEmailAndPassword(auth, email, password)
	await updateProfile(userCredential.user, { displayName: `${firstName} ${lastName}` })
	return userCredential
}

export function passwordResetEmail(email) {
	const auth = getAuth()
	return sendPasswordResetEmail(auth, email)
}

export function userSignOut() {
	const auth = getAuth()
	return signOut(auth)
}

export function signInAnonymousUser() {
	const auth = getAuth()
	return signInAnonymously(auth)
}
